<template lang="pug">
include /mixins

+b.education-form
  +e.content
    validation-provider(
      v-slot="{ errors, validate }"
      :name='name'
      :bails='false'
      :ref='`${name}_valid`'
      :rules='rules'
    )
      div.relative
        input(
          type='hidden',
          :vid='name'
          :name='name'
          :ref='name'
          v-model='selectedValue'
        )
        +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
        v-selection-controller(
          :options='educationLevels'
          :multiple='false',
          :key-getter="$options.keyGetter",
          v-model='selectedValue'
          v-slot="{ options, value: model, change }"
        )
          +b.tt-space_mt--3.tt-space_ml--3(v-for='{ value } in options')
            +b.d-control-static-input--appearance_inline.TAG(
              :rules='{ required: { allowFalse: true } }',
              :tag='"input"'
              :input-label='value.label'
              :key='`key_${name}${value.value}`'
              v-model='model'
              :checked.props='model[0] && model[0].value == value.value'
              :id='`level_${name}_${value.value}`'
              :ref='`level_${name}_${value.value}`'
              @change='change(value); setValue(value)'
              type='radio'
              :name='`${name}name`'
            )
            label.input-group__input(
              :for='`level_${name}_${value.value}`'
            ) {{ value.label }}
  
</template>

<script>
import {
  createDocument,
  deleteDocument,
} from '@api/ticket_management.service'

import TicketManagementGallery from '@app/TicketManagement/Gallery'

import FileLoader from '@app/TicketManagement/FileLoader'

export default {
  name: 'Education',
  keyGetter: x => `${x.value}`,
  props: {
    name: {
      default: 'medical_education_level',
    },
  },
  createDocument,
  deleteDocument,
  components: {
    FileLoader,
    TicketManagementGallery,
  },
  data() {
    return {
      file_name: 'education_documents',
      education_comment: '',
      educationLevels: [
        {
          value: true,
          label: this._('Да'),
          required: true,
        },
        {
          value: false,
          label: this._('Нет'),
          required: true,
        },
      ],
      selectedValue: null,
      rules: { required: false },
    }
  },
  created() {
    this.$emit('input', this.educationLevels[0])
  },
  methods: {
    setKeys(keys) {
      this.files = keys
      this.$emit('update', { education_documents: keys })
    },
    setValue(value) {
      this.selectedValue = value
      this.$emit('input', value)
    },
  },
}
</script>
